import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import { AUAContainer } from '../AUA';
import { connect } from 'react-redux';
import { T } from '../traks';
import { R } from '../routes';
import store from '../store';
import { PremiumHeader } from '../c/Premium/PremiumHeader';
import { PremiumGuide } from '../c/Premium/PremiumGuide';
import { PremiumInfo } from '../c/Premium/PremiumInfo';
import { PremiumPackages } from '../c/Premium/PremiumPackages';
import { PremiumCustomPackagesInfo } from '../c/Premium/PremiumCustomPackagesInfo';
import { PremiumFeatures } from '../c/Premium/PremiumFeatures';

function PremiumInner(props) {
    const [subscription, setSubscription] = useState(props.me && props.me.Subscription ? props.me.Subscription : 'free');

    const subscriptions = {
        free: <T>Not Premium</T>,
        pro: <T>Premium</T>
    }

    useEffect(() => {
        if (props.cart && props.cart.completed) {
            setSubscription('pro');
        }
    }, [props.cart])

    const goToGames = () => {
        R.goto_url('games');
    }

    const goToNewGame = () => {
        R.goto_url('new_game');
    }

    const triggerPremiumCart = () => {
        store.dispatch_value('show_cart', true);
    }

	const faqLink = <T>https://undervisning.aktiedysten.dk/faq-premium/</T>

    return (
        <Row>
            <PremiumHeader />

            <Container>
                <Row className="pt-4 mt-1 premium-status">
                    <Col>
                        <div className="d-flex justify-content-between">
                            <div>
                                <h3><T>Your status:</T> <span className={subscription === 'free' ? 'not-premium-red' : 'premium-green'}>{subscriptions[subscription]}</span></h3>
                            </div>
                            <div className="d-flex justify-content-right">
                                <Row>
                                    <Button onClick={goToGames} className="ml-auto mb-auto mr-2 px-4 py-2"><T>Go to games</T></Button>
                                    <Button onClick={triggerPremiumCart} className="ml-auto mb-auto ad_new_game_button px-4 py-2"><T>Upgrade</T></Button>
                                </Row>
                            </div>
                        </div>
                    </Col>
                </Row>
                <hr className='bg-black'/>
                <PremiumPackages className="mt-4"/>
                <PremiumCustomPackagesInfo />
                <PremiumGuide />
                <PremiumInfo />
                <PremiumFeatures />
            </Container>
        </Row>
	);
}

const Premium = connect(
    (state) => ({
        cart: state.show_cart_game_upgrade
    })
)((props) => <AUAContainer><PremiumInner {...props}/></AUAContainer>);

export default Premium;


// WEBPACK FOOTER //
// ./src/p/Premium.js